const pow4 = (obj) => {
	const tmp = obj * obj;
	return tmp * tmp;
};

export default pow4;
